import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know <strong className="purple">My Expertise</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-react-original-wordmark" />
          <Techstack iconName="devicon-javascript-plain " />
          <Techstack iconName="devicon-typescript-plain " />
          <Techstack iconName="devicon-nodejs-plain-wordmark " />
          <Techstack iconName="devicon-express-original-wordmark" />
          <Techstack iconName="devicon-python-plain-wordmark " />
          <Techstack iconName="devicon-django-plain " />
          <Techstack iconName="devicon-flask-original " />
          <Techstack iconName="devicon-php-plain " />
          <Techstack iconName="devicon-laravel-plain " />
          <Techstack iconName="devicon-nextjs-original " />
          <Techstack iconName="devicon-vuejs-plain" />
          <Techstack iconName="devicon-firebase-plain " />
          <Techstack iconName="devicon-amazonwebservices-original " />
          <Techstack iconName="devicon-postgresql-plain " />
          <Techstack iconName="devicon-mongodb-plain " />
          <Techstack iconName="devicon-mysql-plain " />
          <Techstack iconName="cib-tensorflow" />
        </Row>

        <Github />
      </Container>
    </Container>
  );
}

export default About;
